import axios from 'axios';
import router from '../router';
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: '/api',
  timeout: 10000
});

// 请求拦截器：自动带上 token
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('sso_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器：返回完整 response 对象（含 headers），处理统一错误
service.interceptors.response.use(
  response => ({
    data: response.data,
    headers: response.headers
  }),
  error => {
    let message = '请求失败';
    if (error.response) {
      const status = error.response.status;
      const msg = error.response.data && error.response.data.message;
      if (status === 401) {
        // token 无效或过期，清除登录态并跳转登录页
        message = msg || '登录已过期，请重新登录';
        localStorage.removeItem('sso_token');
        localStorage.removeItem('sso_user');
        // 避免在登录页重复跳转和重复提示
        if (router.currentRoute.path !== '/login') {
          Message.warning(message);
          router.replace({
            path: '/login',
            query: { returnUrl: router.currentRoute.fullPath }
          });
        }
        return Promise.reject(new Error(message));
      }
      message = msg || '请求失败';
    }
    return Promise.reject(new Error(message));
  }
);

export default service;